import { render, staticRenderFns } from "./BuddhismPersonList.vue?vue&type=template&id=69d27161&scoped=true"
import script from "./BuddhismPersonList.vue?vue&type=script&lang=tsx"
export * from "./BuddhismPersonList.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d27161",
  null
  
)

export default component.exports